import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    staticClass: "print-box"
  }, [_c('a-icon', {
    staticClass: "print-icon",
    attrs: {
      "type": "printer"
    }
  }), _vm.message ? _c('p', {
    staticClass: "print-title"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _c('p', {
    staticClass: "print-text"
  }, [_c('a-icon', {
    staticClass: "mr-5",
    attrs: {
      "type": "loading"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.t('正在加载打印内容，请稍等...')))])], 1)], 1)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };